<template>
  <!-- 功能地图模板引擎 -->
  <div class="map_box">
    <div v-for="(mapList, mapindex) in datas" :key="mapindex" class="map">
      <div class="title">
        <img :src="mapList.icon" :alt="mapList.name" />
        <span>{{ mapList.name }}</span>
      </div>
      <div class="map_list">
        <span
          v-for="(mapListItem, index) in mapList.list"
          :key="index"
          @mouseenter="mapMouse(mapListItem, index, mapindex)"
          @click="mapClick(mapListItem, index, mapindex)"
        >
          <a
            v-if="mapindex + '-' + index == '6-3'"
            :class="locationNum == '6-3' ? 'span_active1' : ''"
            style="cursor: pointer;"
            >{{ mapListItem.name }}
          </a>
          <a
            :href="mapListItem.url"
            :class="locationNum == mapindex + '-' + index ? 'span_active' : ''"
            target="_blank"
            v-else
            >{{ mapListItem.name }}
          </a>
        </span>
      </div>
    </div>
      <!-- 收录弹窗 -->
    <div class="backBox" v-show="popupSt">
      <div class="popupBox">
        <div class="topBox">
          <p class="tit">通过文章地址或公众号名称提交收录</p>
          <img
            src="../../../static/images/close.png"
            alt=""
            class="close_img"
            @click="closeMethod"
          />
        </div>
        <div class="botBox">
          <p class="popupTx">
            可提交一篇<span style="color:red">公众号文章的地址</span>或<span style="color:red">公众号名称</span>。系统会根据文章地址收录账号，遗漏收录的文章也可以
            通过此方式提交。
          </p>
          <div class="urlBox">
            <input
              type="text"
              class="centent"
              placeholder="请输入公众号文章地址或公众号名称"
              v-model="included"
            />
            <p class="queryBtn" @click="IncludedMethod" v-if="inclu">收录</p>
            <p class="queryBtn" v-else style="background:#999">收录中...</p>
          </div>
          <div style="color: red; font-size: 12px; margin-top: 14px;font-weight:600;">
            <p>注：收录成功后10分钟内将更新公众号内文章。</p>
            <!-- <p style="padding:0 23px">更新，关注后半小时更新</p> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 收录列表弹窗 -->
   <div class="backBox1" v-show="popupSt1">
      <div class="popupBox">
        <div class="topBox">
          <p class="tit">本次提交收录的相关公众号</p>
          <img
            src="../../../static/images/close.png"
            alt=""
            class="close_img"
            @click="closeMethodpopupSt1"
          />
        </div>
        <div class="topBox1">
          <span class="boxspan" :class="changesls==1?'boxspan1':''" @click="changesl(1)">最新收录(<span style="color:#f73131">{{datalength}}</span>)</span>
          <span class="boxspan" 
          :class="changesls==2?'boxspan1':''" 
          @click="changesl(2)">历史收录(<span style="color:#f73131">{{data2length}}</span>)</span>
        </div>
        <div class="botBox" v-show="!load && changesls==1">
          <div class="botchild" v-for="v in datass.data">
            <div class="childleft">
              <img :src="v.avatar" alt="" @click="todetail(v.mid)">
            </div>
            <div class="childright">
                 <el-tooltip
                effect="dark"
                :content="v.wxname"
                placement="top"
              >
              <p class="rightp1" style="text-align: left !important;" @click="todetail(v.mid)">
              {{v.wxname}}
               </p>
              </el-tooltip>
              <el-tooltip
                effect="dark"
                :content="v.wxid"
                placement="top"
              >
              <p class="rightp2"><span style="transform:scale(0.8);">公众号ID：{{v.wxid}}</span></p>
              </el-tooltip>
              <p class="rightp2"><span>简介：</span>{{v.desc}}</p>
            </div>
          </div>
        </div>
        <div class="botBox" v-show="load">
          <img src="../../../static/images/loding…….gif" alt="" style="width:200px;height:100px;margin:70px 250px;">
        </div>
        <div class="botBox" v-show="!load && changesls==2">
          <div class="botchild" v-for="v in datass.data2">
            <div class="childleft">
              <img :src="v.avatar" alt="" @click="todetail(v.mid)">
            </div>
            <div class="childright">
                 <el-tooltip
                effect="dark"
                :content="v.wxname"
                placement="top"
              >
              <p class="rightp1" @click="todetail(v.mid)" style="text-align: left !important;">
              {{v.wxname}}
               </p>
              </el-tooltip>
              <el-tooltip
                effect="dark"
                :content="v.wxid"
                placement="top"
              >
              <p class="rightp2"><span style="transform:scale(0.8);">公众号ID：{{v.wxid}}</span></p>
              </el-tooltip>
              <p class="rightp2"><span>简介：</span>{{v.desc}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dataSerive",
  data() {
    return {
      //   mapNum: 0,
      locationNum: "",
      popupSt: false,
      included:'',
      // datas:{},
      inclu:true,
      included:'',
      datass:[],
      popupSt1:false,
      datalength:0,
      data2length:0,
      changesls:1,
      load:false,
    };
  },
  props: {
    datas: {
      type: Array,
      default: () => {},
    },
  },
  methods: {
    changesl(e){
            this.changesls = e;
        },
    closeMethodpopupSt1(){
            this.popupSt1 = false;
        },
    todetail(e){
          var routers = 10000;
          sessionStorage.setItem('routernumber', routers);
          let routeUrl = this.$router.resolve({ path: './detail', query: { mid:e,active: 0 } });
          window.open(routeUrl.href, '_blank');
        },
      //号主认证/收录 
          IncludedMethod() {
            var that = this;
            that.datass = [];
            that.datalength='';
            that.data2length = '';
            that.inclu = false;
            that.load = true;
            if(that.included.length>0&&that.included.length<=30){
              that.popupSt1 = true;
                that.$http.axiosFun(that.$api.search.collect_mp, {
                    wxname:that.included,
                }, function(res) {
                    that.inclu = true;
                    that.popupSt1 = true;
                    if (res.msg == 'success') {
                        console.log(res);
                        that.load = false;
                        that.included = '';
                        if (res.data.code==0) {
                            that.$my_message.install({
                                text: res.data.tip,
                                type: 'warning',
                            });
                        } else if (res.data.code==1){
                            that.datass = res.data;
                            that.datalength= res.data.data.length;
                            that.data2length=res.data.data2.length;
                        }
                    } else {
                      that.load = false;
                        that.$my_message.install({
                            text: res.msg,
                            type: 'error',
                        });
                    }
                });
            }else{
                that.$http.axiosFun(that.$api.search.collect_mp, {
                    article_url: that.included,
                }, function(res) {
                    that.inclu = true;
                    if (res.msg == 'success') {
                        console.log(res);
                        that.included = '';
                        if (res.data.is_success) {
                            that.$my_message.install({
                                text: '该公众号已收录，请勿重复提交！',
                                type: 'success',
                            });
                        } else {
                            // that.$message.error(res.data.tip);
                            that.$my_message.install({
                                text: res.data.tip,
                                type: 'error',
                            });
                        }
                    } else {
                        that.load = false;
                        that.$my_message.install({
                            text: res.msg,
                            type: 'error',
                        });
                    }
                });
            }
            
        },
    mapMouse(item, index, mapindex) {
      // this.mapNum = index;
      // if (mapindex + "-" + index == "6-3") {

      // } else {
        this.locationNum = mapindex + "-" + index;
      // }
      // console.log(mapindex + "-" + index);
    },
    mapClick(item, index, mapindex) {
      if (mapindex + "-" + index == "6-3") {
        // console.log("woshi");
        // this.$emit('mapRestive')
        this.popupSt = !this.popupSt;
        // console.log(this.popupSt);
      }
    },
    closeMethod() {
      this.popupSt = false;
    },
  },
};
</script>

<style lang="less" scoped>
.map_box {
  // width: 300px;
  .map {
    width: 100%;
    min-height: 240px;
    display: inline-block;
    // border: solid 1px;
    margin-top: 20px;
    .title {
      width: 80%;
      height: 60px;
      border: solid 1px #eee;
      border-top: none;
      border-left: none;
      border-right: none;
      > img {
        float: left;
        width: 30px;
        height: 30px;
        box-sizing: border-box;
        display: inline-block;
        margin-top: calc(50px / 2 - 30px / 2);
      }
      > span {
        height: 60px;
        display: inline-block;
        float: left;
        box-sizing: border-box;
        width: calc(100% - 40px);
        // border: solid 1px;
        font-size: 24px;
        font-weight: 600;
        line-height: 50px;
        margin-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .map_list {
      //   border: solid 1px greenyellow;
      width: 80%;
      margin-top: 20px;
      font-weight: 500;
      line-height: 35px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-size: 18px;
      > span {
        display: inline-block;
        width: 100%;
        // border: solid 1px blue;
        height: 30px;
        > a {
          text-decoration: none;
          color: #333;
        }
      }
      .span_active {
        font-weight: 500;
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        color: #20a0ff;
      }
      .span_active1 {
        font-weight: 500;
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        color: #20a0ff;
      }
    }
  }
}
// 收录
  .backBox{
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.4);
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  .popupBox{
    width: 600px;
    height: 340px;
    border-radius: 10px;
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
     .topBox{
      height: 60px;
      z-index: 10;
      line-height: 60px;
      // border-bottom: 2px solid #E5E5E5;
      .tit{
        font-size: 22px;
        font-weight: bold;
        text-align: center;
      }
      .close_img{
        width: 18px;
        height: 18px;
        position: absolute;
        right: 30px;
        top: 20px;
        cursor: pointer;
      }
    }
    .topBox1{
      height: 60px;
      z-index: 10;
      width: 60%;
      margin: 0 auto;
      // margin-bottom: 10px;
      line-height: 60px;
      // border-bottom: 2px solid #E5E5E5;
      font-size: 20px;
      display: flex;
      justify-content: space-between;
      .boxspan{
        
        cursor: pointer;
        width: 118px;
        color: #666;
      }
      .boxspan1{
        color: #20A0FF;
        border-bottom: 2px solid #20A0FF;
      }
    }
    .botBox{
      padding: 30px;
      .popupTx{
        font-size: 14px;
        color: #666666;
      }
      .urlBox{
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        .centent{
          width: 400px;
          height: 36px;
          padding-left: 10px;
          background: #F5F5F5;
          border:1px solid #CCCCCC;
          border-radius: 5px;
          outline: none;
        }
        .queryBtn{
          width: 100px;
          height: 40px;
          border-radius: 5px;
          background: #20A0FF;
          color: white;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          cursor:pointer;
        }
      }
    }

  }
}
.backBox1{
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.4);
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  .popupBox{
    width: 1010px;
    height: 550px;
    // overflow-x: none;
    border-radius: 10px;
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
      .topBox{
      height: 60px;
      z-index: 10;
      line-height: 60px;
      // border-bottom: 2px solid #E5E5E5;
      .tit{
        font-size: 22px;
        font-weight: bold;
        text-align: center;
      }
      .close_img{
        width: 18px;
        height: 18px;
        position: absolute;
        right: 30px;
        top: 20px;
        cursor: pointer;
      }
    }
    .topBox1{
      height: 60px;
      z-index: 10;
      width: 60%;
      margin: 0 auto;
      line-height: 60px;
      font-size: 20px;
      display: flex;
      justify-content: space-between;
      .boxspan{
        
        cursor: pointer;
        width: 118px;
        color: #666;
      }
      .boxspan1{
        color: #20A0FF;
        border-bottom: 2px solid #20A0FF;
      }
    }
    .botBox{
      padding: 10px;
      height:390px;
      overflow: auto;
      .botchild{
        width: 310px;
        height:100px;
        float: left;
        margin: 10px 5px;
        border:1px solid #bebebe;
        border-radius: 3px;
        .childleft{
          width: 70px;
          height:100%;
          float: left;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img{
            width: 65px;
            height:65px;
          }
        }
        .childright{
          float: right;
          padding: 10px 0px;
          width: 235px;
          height:100%;
         .rightp1{
           width: 100%;
           height:30px;
           font-size: 16px;
           color:#333;
           font-weight: 500;
           cursor: pointer;
           overflow: hidden;
           text-overflow:ellipsis;
           white-space: nowrap;
        }
        .rightp2{
          width: 100%;
          height:25px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          font-size: 12px;
          color:rgb(138, 136, 136);
          line-height: 20px;
          font-weight: 500;
          cursor: pointer; 
          text-align: left !important; 
       }
      }
      }
    }
    .botBox::-webkit-scrollbar {
      width: 6px;
      height: 1px;
      border:none;
      background-color: #fff;
    }
    .botBox::-webkit-scrollbar-thumb{
      border-radius: 6px;
      background:#25344E;
    }
  }
  .loadingo{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height:100%;
    background: rgba(0,0,0,0.3);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/functionMap/map-templete.vue